import { isValidEmail, isValidPassword, isNonEmpty } from '../helpers/validators';
import { validateEmail } from './validations/validateEmail';
import { validateLogin } from './validations/validateLogin';
import { validatePassword } from './validations/validatePassword';

export { validateEmail, validatePassword, validateLogin };

export const validateEmailString = (email: string): string | null => {
    if (!isNonEmpty(email)) {
        return 'Email address is required';
    } else if (!isValidEmail(email)) {
        return 'Please enter a valid email address.';
    }
    return null;
};

export function validatePasswordString(password: string): string | null {
    if (!isNonEmpty(password)) {
        return 'Password is required.';
    } else if (!isValidPassword(password)) {
        return 'Please enter a minimum of 5 characters.';
    }
    return null;
}
